(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unfindable-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let cleanup = () => {};
  function init() {
    cleanup();
    const roots = [...document.querySelectorAll('[data-uph]')];
    if (!roots.length || reduce.matches) { roots.forEach(root => root.classList.remove('uph-motion')); return; }
    const targets = roots.flatMap(root => [...root.querySelectorAll('[data-reveal]')]);
    const visuals = roots.flatMap(root => [...root.querySelectorAll('[data-motion]')]);
    roots.forEach(root => root.classList.add('uph-motion'));
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting) {entry.target.classList.add('uph-visible'); observer.unobserve(entry.target);} }), {threshold:.08,rootMargin:'0px 0px -24px 0px'});
    targets.forEach(target => observer.observe(target));
    let pending=false;
    const frame = () => { pending=false; const height=innerHeight; const strength=innerWidth<750?18:44; visuals.forEach(visual => {const rect=visual.getBoundingClientRect(); if(rect.bottom<0 || rect.top>height) return; const position=Math.max(-1,Math.min(1,((rect.top+rect.height/2)-height/2)/height)); visual.style.setProperty('--up-y', `${(position*strength).toFixed(2)}px`);}); };
    const scroll = () => {if(!pending){pending=true;requestAnimationFrame(frame);}};
    addEventListener('scroll',scroll,{passive:true});addEventListener('resize',scroll);frame();
    cleanup=()=>{observer.disconnect();removeEventListener('scroll',scroll);removeEventListener('resize',scroll);roots.forEach(root=>root.classList.remove('uph-motion'));};
  }
  init();document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',init);reduce.addEventListener('change',init);
})();

  } catch(e) { console.error(e); }
})();
})();
